<div class="chat-bot">
  <img
    *ngIf="!toggle"
    width="40px"
    height="50px"
    src="../../../../assets/icons/bot.png"
    (click)="closeFun()"
  />
  <div
    class="frame"
    id="frame1"
    style="
      width: 270px;
      height: 350px;
      position: absolute;
      right: 0px;
      bottom: 0px;
    "
    *ngIf="toggle"
  >
    <iframe
      src="https://console.dialogflow.com/api-client/demo/embedded/ea1ee254-90b5-45f6-8ad9-857a68835cae"
      title="Iframe Example"
      style="width: 100%; height: 100%"
    ></iframe>
    <button
      class="btn close"
      style="position: relative; float: right; right: 8px; bottom: 352px"
      (click)="closeFun()"
    >
      &times;
    </button>
  </div>
</div>
<!-- move top icon -->
<a class="fa fa-arrow-circle-up move-up text-center totop"></a>
<!-- //move top icon -->
<footer
  class="text-white text-lg-start"
  style="background-color: #2a2a2a; margin-top: 6%"
>
  <!-- Grid container -->
  <div class="container p-4">
    <!--Grid row-->
    <div class="row">
      <!--Grid column-->
      <div class="text-center col-lg-6 col-md-12 mb-4 mb-md-0">
        <h3>BJMC & Sassoon General Hospital</h3>
        <span>
          <p>
            <i class="fa fa-map-marker" aria-hidden="true"></i>
            <a
              class="text-white"
              href="https://goo.gl/maps/DQYtWZV7ZaFMb5zH8"
              target="_blank"
              >Jai Prakash Narayan Road, Railway Station Rd, near Pune,
              Maharashtra 411001</a
            >
          </p>
        </span>

        <p>
          <i class="fa fa-phone" aria-hidden="true"></i>
          <a
            href="tel:>020 26128000"
            style="color: white; text-decoration: none; font-size: 16px"
            >020 26128000</a
          >
        </p>
        <p>
          <i class="fa fa-envelope" aria-hidden="true"></i>
          <a
            href="mailto: deanbjmcpune@gmail.com"
            style="color: white; text-decoration: none; font-size: 16px"
            >deanbjmcpune@gmail.com</a
          >
        </p>
      </div>
      <!--Grid column-->

      <!--Grid column-->
      <div class="footer-content col-lg-3 col-md-6 mb-4 mb-md-0">
        <h3>Useful links</h3>

        <ul class="fa-ul">
          <li>
            <i
              class="fa fa-chevron-right"
              aria-hidden="true"
              style="font-size: smaller"
            ></i>
            <a href="#" routerLink="/about-us/deans">Dean</a>
          </li>
          <li>
            <i
              class="fa fa-chevron-right"
              aria-hidden="true"
              style="font-size: smaller; text-align: left"
            ></i>
            <a href="#" routerLink="/students-corner/results">Results</a>
          </li>
          <li>
            <i
              class="fa fa-chevron-right"
              aria-hidden="true"
              style="font-size: smaller; text-align: left"
            ></i>
            <a href="#" routerLink="/staff/teaching">Teaching staff</a>
          </li>
          <li>
            <i
              class="fa fa-chevron-right"
              aria-hidden="true"
              style="font-size: smaller; text-align: left"
            ></i>
            <a href="#" routerLink="/resources/journals">Journals</a>
          </li>
        </ul>
      </div>
      <!--Grid column-->

      <!--Grid column-->
      <div class="footer-content col-lg-3 col-md-6 mb-4 mb-md-0">
        <h3>Quick links</h3>

        <ul class="fa-ul">
          <li>
            <i
              class="fa fa-chevron-right"
              aria-hidden="true"
              style="font-size: smaller"
            ></i>
            <a href="#" routerLink="/hospital">Hospital</a>
          </li>
          <li>
            <i
              class="fa fa-chevron-right"
              aria-hidden="true"
              style="font-size: smaller"
            ></i>
            <a href="#" routerLink="/departments">Departments</a>
          </li>
          <li>
            <i
              class="fa fa-chevron-right"
              aria-hidden="true"
              style="font-size: smaller"
            ></i>
            <a href="#" routerLink="/about-us/university">University</a>
          </li>
          <li>
            <i
              class="fa fa-chevron-right"
              aria-hidden="true"
              style="font-size: smaller"
            ></i>
            <a href="#" routerLink="/about-us/recognition">Recognition</a>
          </li>
        </ul>
      </div>
      <!--Grid column-->
    </div>
    <!--Grid row-->
  </div>
  <!-- Grid container -->

  <!-- Copyright -->
  <div class="text-center p-3">
    © 2021 B. J. Medical College & Sassoon Hospital. All right reserved.
    <!-- <a class="text-white" href="https://mdbootstrap.com/">MDBootstrap.com</a> -->
  </div>
  <!-- Copyright -->
</footer>
